import React, { useState, useEffect } from "react";
import CustomLabel from "../controls/CustomLabel";
import "./../../assets/css/AddPrescriptionItem.scss";
import { inputTypes } from "../../enum/inputTypes";
import { drugNames } from "../../data/drugNames";
import TextField from "@mui/material/TextField";
import IconSVG from "./../../assets/images/icon-drug.svg";
import useTitanApp from "../../hooks/useTitanApp";
import { IoIosWarning } from "react-icons/io";
import { getDrugInformation } from "../../dispatchers/nmsDispatchers";
import DrugSkeleton from "./DrugSkeleton";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import SearchableMadicineDropdown from "./SearchableMadicineDropdown";
import { countryNames } from "../../utils/countries";
import Flag from "react-world-flags";
import { Tag } from "primereact/tag";
import { getClassName } from "../../data/getColorType";

function AddPrescriptionMadicine({
  template,
  number,
  isCompleted,
  stageStatus,
  patientNameChange,
  templateRequired,
  handleTemplateData,
  groupId,
}) {
  const { nmsServiceState } = useTitanApp();
  const {
    drugsData,
    drugsAboutData,
    isDrugInformationLoading,
    timelineElements,
    service,
  } = nmsServiceState || {};
  const stage = service?.stages[0];
  const { userControls, sectionTitle } = template || {};

  useEffect(() => {
    setInputValues(userControls);
    const updatedObj = drugNames.filter(
      (item) => item.drugName === sectionTitle
    );
    setData(...updatedObj);
  }, [userControls]);

  const [inputValues, setInputValues] = useState(userControls);
  const [infoMessage, setInfoMessage] = useState(false);
  const [value, setValue] = useState("");
  const [data, setData] = useState();
  let rowCount = 0;

  const handleFormChange = async (index, event, type, labelName, itemValue) => {
    let value;
    let updatedTimelineElements;
    if (type === "Radio") {
      const itemValue = event.target.checked ? "true" : "false";
      value = itemValue;

      // Retrieve the existing element index in the timelineElements array
      const existingElementIndex = timelineElements.findIndex(
        (element) => element.title === sectionTitle
      );

      if (itemValue === "false" && existingElementIndex !== -1) {
        // Remove the item if the switch is false and the element exists
        const updatedListItems = timelineElements[
          existingElementIndex
        ].listItems.filter((item) => item.label !== labelName);

        const updatedTimelineElement = {
          ...timelineElements[existingElementIndex],
          listItems: updatedListItems,
        };

        updatedTimelineElements = [
          ...timelineElements.slice(0, existingElementIndex),
          updatedTimelineElement,
          ...timelineElements.slice(existingElementIndex + 1),
        ];

        //setCurrentTimelineElements(updatedTimelineElements);
      } else if (itemValue === "true") {
        // Add the item if the switch is true
        const timelineListItemObj = {
          label: labelName,
          value: itemValue,
          type: type,
        };

        if (existingElementIndex !== -1) {
          // If the title exists, merge the list items
          const updatedListItems = [
            ...timelineElements[existingElementIndex].listItems,
            timelineListItemObj,
          ];

          const updatedTimelineElement = {
            ...timelineElements[existingElementIndex],
            listItems: updatedListItems,
          };

          updatedTimelineElements = [
            ...timelineElements.slice(0, existingElementIndex),
            updatedTimelineElement,
            ...timelineElements.slice(existingElementIndex + 1),
          ];

          //setCurrentTimelineElements(updatedTimelineElements);
        } else {
          // If the title doesn't exist, create a new object
          const timelineElementsObj = {
            name: sectionTitle,
            title: sectionTitle,
            value: sectionTitle,
            listItems: [timelineListItemObj],
            elementType: 8,
          };

          updatedTimelineElements = [...timelineElements, timelineElementsObj];
          // setCurrentTimelineElements(updatedTimelineElements);
        }
      }
    } else {
      value = event?.target?.value;

      const existingElementIndex = timelineElements.findIndex(
        (element) => element.title === sectionTitle
      );

      const timelineListItemObj = {
        label: labelName,
        value: value,
        type: type,
      };

      let updatedListItems;

      if (existingElementIndex !== -1) {
        // If the title exists, merge the list items
        const listitems = timelineElements[existingElementIndex].listItems;
        let otherIndex = listitems.findIndex(
          (item) => item.label === labelName
        );
        if (otherIndex !== -1) {
          updatedListItems = listitems?.map((item, index) => {
            if (index === otherIndex) {
              // Modify the specific element at otherIndex
              return {
                ...item,
                value: value,
              };
            }
            return item;
          });
        } else {
          updatedListItems = [
            ...timelineElements[existingElementIndex].listItems,
            timelineListItemObj,
          ];
        }

        const updatedTimelineElement = {
          ...timelineElements[existingElementIndex],
          listItems: updatedListItems,
        };

        updatedTimelineElements = [
          ...timelineElements.slice(0, existingElementIndex),
          updatedTimelineElement,
          ...timelineElements.slice(existingElementIndex + 1),
        ];

        // setCurrentTimelineElements(updatedTimelineElements);
      } else {
        // If the title doesn't exist, create a new object
        const timelineElementsObj = {
          name: sectionTitle,
          title: sectionTitle,
          value: sectionTitle,
          listItems: [timelineListItemObj],
          elementType: 7,
        };

        updatedTimelineElements = [...timelineElements, timelineElementsObj];
        // setCurrentTimelineElements(updatedTimelineElements);
      }
    }
    const UserControlObj = await setUserControl(index, value);
    handleTemplateData(
      sectionTitle,
      UserControlObj,
      groupId,
      updatedTimelineElements
    );
  };

  const setUserControl = async (index, value) => {
    let newUserControl;
    setInputValues((prevInputValues) => {
      const updatedData = prevInputValues.map((item, i) =>
        i === index ? { ...item, value } : item
      );
      newUserControl = updatedData;
      return updatedData;
    });
    return newUserControl;
  };

  function handleMedicineName(val) {
    setValue(val?.drugName);
    var response = getDrugInformation(val?.prescribedItemId);
    if (response !== null) {
      setInfoMessage(true);
    }
  }
  const checkCountryExists = (sectionTitle) => {
    return countryNames.some(
      (country) => country?.name?.toLowerCase() === sectionTitle?.toLowerCase()
    );
  };
  const getCountryLogo = (countryName) => {
    const country = countryNames.find(
      (c) => c.name.toLowerCase() === countryName.toLowerCase()
    );
    return country ? country.code : null;
  };
  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor:
            theme.palette.mode === "dark" ? "#177ddc" : "#1890ff",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === "dark"
          ? "rgba(255,255,255,.35)"
          : "rgba(0,0,0,.25)",
      boxSizing: "border-box",
    },
  }));

  return (
    <div
      className="parent_template ps-add-template"
      style={{
        borderLeft: "2px solid #00ca69",
      }}
    >
      <div className="medicine-card customcard">
        <div
          className="card-step-number"
          style={{
            background: "#00ca69",
          }}
        >
          <h2>{number}</h2>
        </div>
        <div className="card-content ps-add-item">
          <div className="card-actions nms-title">
            <div className="d-flex">
              <IconSVG class />
              <h2 class="medicine-card-heading">{sectionTitle}</h2>
            </div>
          </div>
          {stage?.template?.templateSections.map((section, index) => {
            if (checkCountryExists(section?.sectionTitle)) {
              return (
                <div key={index} className="inline">
                  <div
                    style={{
                      border: "#00ca69",
                    }}
                    className="flag-country-risk"
                  >
                    <div className="flag-country-risk-name">
                      {" "}
                      <Flag
                        width={30}
                        height={24}
                        code={getCountryLogo(section?.sectionTitle)}
                      />
                      <CustomLabel name={section?.sectionTitle} />
                    </div>

                    <div className="flag-country-risk-tags">
                      <Tag
                        severity="custom"
                        style={{
                          background: "red",
                        }}
                        className="color-tag"
                        value={
                          <span className={getClassName("red")}>High risk</span>
                        }
                      />
                    </div>
                  </div>
                </div>
              );
            }
          })}

          <div className="accordion-boxes">
            {inputValues?.map((item, index) => {
              if (item.inline === true) {
                rowCount > 2 ? (rowCount = 0) : rowCount++;
              }

              if (item.type === 5) {
                return (
                  <React.Fragment key={index}>
                    <div
                      className={item.inline === true ? "inline-not" : "inline"}
                    >
                      <div
                        style={{
                          border: templateRequired
                            ? "1px solid #E22424"
                            : "#00ca69",
                        }}
                        className="switch-content-reports-outer toggle-only ps-inner-switch-content"
                        onClick={(event) =>
                          handleFormChange(
                            index,
                            { target: { checked: !JSON.parse(item?.value) } },
                            inputTypes[item?.type],
                            item?.label,
                            item?.value
                          )
                        }
                      >
                        <CustomLabel name={item.label} />

                        <div>
                          <AntSwitch
                            disabled={stageStatus}
                            inputProps={{ "aria-label": "ant design" }}
                            onChange={(event) =>
                              handleFormChange(
                                index,
                                event,
                                inputTypes[item.type],
                                item.label,
                                item.value
                              )
                            }
                            checked={
                              item.value === "" ? false : JSON.parse(item.value)
                            }
                          />
                        </div>
                      </div>
                    </div>
                    {rowCount > 2 ? <br /> : <></>}
                  </React.Fragment>
                );
              }
              if (item.type === 7) {
                return (
                  <React.Fragment key={index}>
                    <div
                      className={item.inline === true ? "inline-not" : "inline"}
                    >
                      <div className="medicine-drop-down not-disp-reason">
                        <div className="medicine-dose-button">
                          <CustomLabel name="Medicine Name" />
                          {value !== "" ? (
                            <button className="dose-button">ADD</button>
                          ) : (
                            <></>
                          )}
                        </div>

                        <SearchableMadicineDropdown
                          searchType="drug"
                          label="name"
                          id="id"
                          selectedVal={value === "" ? item?.value : value}
                          handleChange={handleMedicineName}
                          options={drugNames}
                        />
                      </div>
                    </div>
                    {rowCount > 2 ? <br /> : <></>}
                  </React.Fragment>
                );
              }
              if (item.type === 0) {
                return (
                  <React.Fragment key={index}>
                    <div
                      className={item.inline === true ? "inline-not" : "inline"}
                    >
                      <div className="template_control">
                        <TextField
                          className="template_input text_input_field ps-input-field"
                          error={
                            item.required
                              ? isCompleted === true
                                ? item.value === ""
                                  ? true
                                  : false
                                : false
                              : false
                          }
                          required
                          id="outlined-required"
                          disabled={stageStatus}
                          value={
                            item.label === "Patient Name"
                              ? patientNameChange === null
                                ? item.value
                                : patientNameChange
                              : item.value
                          }
                          label={item.label}
                          onChange={(event) =>
                            handleFormChange(
                              index,
                              event,
                              inputTypes[item.type],
                              item.label,
                              item.value
                            )
                          }
                          inputProps={{ maxLength: 5000 }}
                        />
                      </div>
                    </div>

                    {rowCount > 2 ? <br /> : <></>}
                  </React.Fragment>
                );
              }
            })}
          </div>
          {isDrugInformationLoading ? (
            <>
              <DrugSkeleton />
            </>
          ) : (
            <>
              {drugsData.length > 0 ? (
                <div className="age-presc">
                  {drugsData.map((data, index) => (
                    <div className="presc" key={index}>
                      <p className="title">{data.type}</p>
                      <div className="d-flex">
                        <p className="description">{data.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <></>
              )}
              {drugsAboutData.length > 0 ? (
                <div className="about-presc">
                  {drugsAboutData.map((data) => (
                    <div className="about">
                      <div className="d-flex">
                        <IoIosWarning color="#3EF420" />
                        <p className="title">{data.type}</p>
                      </div>
                      <p>{data.description}</p>
                    </div>
                  ))}
                </div>
              ) : (
                infoMessage === true && (
                  <div className="error-msg">
                    <p>Medicine information is not available!</p>
                  </div>
                )
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AddPrescriptionMadicine;

